import React from "react";
import { MapPin, Loader2, ChevronRight } from "lucide-react";
import { highlightMatch } from "./utils";

const AddressInput = ({
    addressInputRef,
    address,
    onAddressChange,
    isLoading,
    isLimitReached,
    isLoadingAddress,
    addressSuggestions,
    onAddressSelect,
    analysisMode,
    primaryAddress,
    planTier,
    searchLimit,
    selectedCity,
    selectedState
}) => {
    return (
        <div className="relative">
            <div className="flex items-center justify-between mb-2.5">
                <label className="block text-sm font-semibold text-slate-800">
                    {analysisMode === "merged" && primaryAddress ? "Add Property to Combined Lot" : "Property Address"}
                </label>
            </div>
            <input
                ref={addressInputRef}
                type="text"
                value={address}
                onChange={onAddressChange}
                disabled={isLoading || isLimitReached}
                placeholder={
                    isLimitReached
                        ? `${planTier} limit reached (${searchLimit}/${searchLimit})`
                        : analysisMode === "merged" && primaryAddress
                            ? "Search & add another property to combine..."
                            : `e.g., 13480... ${selectedCity || "Los Altos Hills"}, ${selectedState || "CA"}`
                }
                className={`w-full px-4 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all placeholder-slate-500 font-medium text-sm disabled:opacity-50 disabled:cursor-not-allowed ${isLimitReached ? 'bg-slate-50 text-slate-400' : 'text-slate-900'}`}
            />
            {isLoadingAddress && (
                <div className="absolute right-3 top-12">
                    <Loader2 className="h-4 w-4 animate-spin text-slate-400" />
                </div>
            )}
            {addressSuggestions.length > 0 && (
                <ul className="absolute z-50 mt-1 w-full rounded-xl border border-slate-200 bg-white shadow-xl max-h-[400px] overflow-y-auto scrollbar-thin scrollbar-thumb-slate-200 scrollbar-track-transparent py-2">
                    {addressSuggestions.map((prediction) => {
                        const mainText = prediction.structured_formatting.main_text;
                        const secondaryText = prediction.structured_formatting.secondary_text;

                        // Split match parts for Zillow-style highlighting
                        const matches = prediction.structured_formatting.main_text_matched_substrings || [];

                        return (
                            <li
                                key={prediction.place_id}
                                onClick={() => onAddressSelect(prediction)}
                                className="group cursor-pointer px-4 py-3 hover:bg-blue-50/80 transition-colors border-b border-slate-50 last:border-b-0"
                            >
                                <div className="flex items-center gap-3">
                                    <div className="flex-shrink-0 w-10 h-10 rounded-full bg-slate-50 flex items-center justify-center group-hover:bg-blue-100 transition-colors">
                                        <MapPin className="h-5 w-5 text-slate-400 group-hover:text-blue-600 transition-colors" />
                                    </div>
                                    <div className="flex flex-col min-w-0">
                                        <div className="text-sm font-semibold text-slate-900 truncate">
                                            {highlightMatch(mainText, matches)}
                                        </div>
                                        <div className="text-xs text-slate-500 truncate mt-0.5">
                                            {secondaryText}
                                        </div>
                                    </div>
                                    <ChevronRight className="ml-auto h-4 w-4 text-slate-300 opacity-0 group-hover:opacity-100 transition-all -translate-x-2 group-hover:translate-x-0" />
                                </div>
                            </li>
                        );
                    })}
                </ul>
            )}
        </div>
    );
};

export default AddressInput;
